import React from "react";
import { Card, Form } from "antd";

function ESignature({ data }) {
  return (
    <div className="e-signature">
      <Card title="E-Signature">
        <Form labelCol={{ span: 8 }} colon={false}>
          <Form.Item label="Authorized By">
            <p>Robert Sullivan</p>
          </Form.Item>
          <Form.Item label="Date">
            <p>02/08/2021</p>
          </Form.Item>
        </Form>
      </Card>
    </div>
  );
}

export default ESignature;
